import React from 'react';

import { setIn } from '@lyearn/core/utils/immutable';
import NumberInput from '@/components/NumberInput';

import { FrequencyComponentProps } from '../../../../types';

const CustomFrequencyInput: React.FC<FrequencyComponentProps> = React.memo(
  ({ value, onChange, disabled, size }) => {
    const onFrequencyChange = React.useCallback(
      (newValue: number) => {
        onChange(setIn(value, ['custom', 'interval'], newValue));
      },
      [onChange, value],
    );

    return (
      <NumberInput
        canBeEmpty={false}
        disabled={disabled}
        min={1}
        size={size ?? 'large'}
        value={value.custom?.interval || 0}
        onChange={onFrequencyChange}
      />
    );
  },
);

export default CustomFrequencyInput;
